import React, { useEffect, useState } from 'react';

const Fireworks = ({ duration = 3000 }) => {
  const [fireworks, setFireworks] = useState([]);
  const [sparkles, setSparkles] = useState([]);

  useEffect(() => {
    const colors = ['gold', 'orange', 'red', 'blue', 'green'];
    const newFireworks = [];
    const newSparkles = [];

    // Create multiple bursts of fireworks
    for (let burst = 0; burst < 3; burst++) {
      setTimeout(() => {
        // Create fireworks for this burst
        for (let i = 0; i < 8; i++) {
          const firework = {
            id: `firework-${burst}-${i}`,
            left: Math.random() * 100,
            top: Math.random() * 100,
            color: colors[Math.floor(Math.random() * colors.length)],
            delay: Math.random() * 500,
          };
          newFireworks.push(firework);

          // Create sparkles around each firework
          for (let j = 0; j < 5; j++) {
            const sparkle = {
              id: `sparkle-${burst}-${i}-${j}`,
              left: firework.left + (Math.random() - 0.5) * 10,
              top: firework.top + (Math.random() - 0.5) * 10,
              delay: firework.delay + Math.random() * 300,
            };
            newSparkles.push(sparkle);
          }
        }

        setFireworks(prev => [...prev, ...newFireworks.slice(burst * 8, (burst + 1) * 8)]);
        setSparkles(prev => [...prev, ...newSparkles.slice(burst * 40, (burst + 1) * 40)]);
      }, burst * 800);
    }

    // Clean up after animation completes
    const cleanup = setTimeout(() => {
      setFireworks([]);
      setSparkles([]);
    }, duration);

    return () => clearTimeout(cleanup);
  }, [duration]);

  return (
    <div className="fireworks-container">
      {fireworks.map((firework) => (
        <div
          key={firework.id}
          className={`firework ${firework.color}`}
          style={{
            left: `${firework.left}%`,
            top: `${firework.top}%`,
            animationDelay: `${firework.delay}ms`,
          }}
        />
      ))}
      {sparkles.map((sparkle) => (
        <div
          key={sparkle.id}
          className="sparkle"
          style={{
            left: `${sparkle.left}%`,
            top: `${sparkle.top}%`,
            animationDelay: `${sparkle.delay}ms`,
          }}
        />
      ))}
    </div>
  );
};

export default Fireworks;
